import { render, staticRenderFns } from "./FormUgd.vue?vue&type=template&id=2e7c98ab&"
import script from "./FormUgd.vue?vue&type=script&lang=js&"
export * from "./FormUgd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports